import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { useParams } from 'react-router';

/**
 * Returns the loaded fragment for the current route, its station, and total duration in ms.
 */
export function useFragment() {
  const { fragmentId } = useParams<{ fragmentId: string }>();
  const fragmentQuery = useFragmentQuery(fragmentId!);

  const finder = useStationsFinder();

  if (!fragmentQuery.data) {
    throw new Error(`Fragment with id ${fragmentId} not loaded`);
  }

  const fragment = fragmentQuery.data;
  const station = finder(fragment.stationId)!;
  const durationMs = fragment.chunks.reduce((sum, chunk) => sum + chunk.duration, 0);

  return {
    fragment,
    station,
    durationMs,
  };
}
